import { BasicRecord, ByCountyRecord, OverallRecord, ProvidersResult } from "@app/shared/data-summaries";
import { SummaryResultNetworkType, SummaryResultScope, SummaryResultType } from "@app/shared/data-summaries/enumerations";
import ServiceBase from "@app/shared/serviceBase";
import { querystringify } from "@app/shared/utility/querystringify";
import { SortDirections } from "@app/shared/waffles";

/** Manages data access for all summary information. */
export default class SummaryService extends ServiceBase {
  public async getOverall(projectId: number, runConfigurationId: number, scope: SummaryResultScope): Promise<OverallRecord[]> {
    return await this.makeGet<OverallRecord[]>(`summaries/${projectId}/projectrunconfiguration/${runConfigurationId}/${encodeURIComponent(scope)}/overall`);
  }

  public async getBySpecialty(projectId: number, runConfigurationId: number, scope: SummaryResultScope): Promise<BasicRecord[]> {
    return await this.makeGet<BasicRecord[]>(`summaries/${projectId}/projectrunconfiguration/${runConfigurationId}/${encodeURIComponent(scope)}/byspecialty`);
  }

  public async getByCounty(projectId: number, runConfigurationId: number, scope: SummaryResultScope): Promise<ByCountyRecord[]> {
    return await this.makeGet<ByCountyRecord[]>(`summaries/${projectId}/projectrunconfiguration/${runConfigurationId}/${encodeURIComponent(scope)}/bycounty`);
  }

  public async getByState(projectId: number, runConfigurationId: number, scope: SummaryResultScope): Promise<BasicRecord[]> {
    return await this.makeGet<BasicRecord[]>(`summaries/${projectId}/projectrunconfiguration/${runConfigurationId}/${encodeURIComponent(scope)}/bystate`);
  }

  public async getByGeocode(projectId: number, runConfigurationId: number, scope: SummaryResultScope): Promise<BasicRecord[]> {
    return await this.makeGet<BasicRecord[]>(`summaries/${projectId}/projectrunconfiguration/${runConfigurationId}/${encodeURIComponent(scope)}/bygeocode`);
  }

  public async getByNPIStatus(projectId: number, runConfigurationId: number, scope: SummaryResultScope): Promise<BasicRecord[]> {
    return await this.makeGet<BasicRecord[]>(`summaries/${projectId}/projectrunconfiguration/${runConfigurationId}/${encodeURIComponent(scope)}/bynpistatus`);
  }

  public async getByNumSpecialties(projectId: number, runConfigurationId: number, scope: SummaryResultScope): Promise<BasicRecord[]> {
    return await this.makeGet<BasicRecord[]>(`summaries/${projectId}/projectrunconfiguration/${runConfigurationId}/${encodeURIComponent(scope)}/byspecialtycount`);
  }

  public async getByNumAddresses(projectId: number, runConfigurationId: number, scope: SummaryResultScope): Promise<BasicRecord[]> {
    return await this.makeGet<BasicRecord[]>(`summaries/${projectId}/projectrunconfiguration/${runConfigurationId}/${encodeURIComponent(scope)}/byaddresscount`);
  }

  public async getProviders(projectId: number, runConfigurationId: number, scope: SummaryResultScope, networkType: SummaryResultNetworkType, resultType: SummaryResultType, key: string, skip: number, searchValue: string, sortKey: string, sortDirection: SortDirections): Promise<ProvidersResult> {
    return await this.makeGet<ProvidersResult>(`summaries/${projectId}/projectrunconfiguration/${runConfigurationId}/${encodeURIComponent(scope)}/providers/${encodeURIComponent(networkType)}/${encodeURIComponent(resultType)}?${querystringify({ key, searchValue, skip, sortDirection, sortKey, take: 100 })}`);
  }
}
